import { useEffect } from 'react'

import { FLUTTER_ACTIONS, MessageToFlutter } from 'lib/config/appBridge'

export const useBgTheme = (hex_color: string) => {
  useEffect(() => {
    hex_color &&
      MessageToFlutter({
        action: FLUTTER_ACTIONS.UPDATE_THEME_COLOR,
        data: {
          hex_color,
        },
      })
  }, [hex_color])
}
